import { ExportFormat } from '@cdw-ae/common-data';

export interface FormatLimit {
  maxCells: number;
  displayName: string;
}

export const EXPORT_FORMAT_LIMITS: Partial<Record<ExportFormat, FormatLimit>> = {
  [ExportFormat.GOOGLE_SHEETS]: {
    maxCells: 10_000_000,
    displayName: 'Google Sheets',
  },
};

export const CELL_LIMIT_WARNING_THRESHOLD = 0.8;
